import { NestedTeam } from "@revelate/types";

export const getUserIdsForTeam = (
  teams: NestedTeam[],
  id: number,
  forCalculation = false
) => {
  const team = teams.find((team) => team.id === id);
  if (!team) return [];
  return team.users
    .filter((user) => (forCalculation ? user.include_in_calculations : true))
    .map((user) => user.id.toString());
};
